import { render, staticRenderFns } from "./ComplianceWorstPerformingOwners.vue?vue&type=template&id=61ea8a67&"
import script from "./ComplianceWorstPerformingOwners.vue?vue&type=script&lang=ts&"
export * from "./ComplianceWorstPerformingOwners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports